import styled from '@emotion/styled'

import {NoStyleLink} from '@vio/atlas/helpers/NoStyleLink'
import {Text} from '@vio/atlas/Text'
import {cssTheme} from '@vio/atlas/themes'
import {linariaMq} from '@vio/atlas/utils/breakpoints'
import minus from '@vio/atlas/utils/minus'

import {CARD_WIDTH} from './constants'

export const SectionWrapper = styled.div`
  padding-top: ${cssTheme.layout.spacing.s300};
  padding-bottom: ${cssTheme.layout.spacing.s600};
  min-width: 0;
  width: calc(100% + 2 * ${cssTheme.layout.spacing.s400});
  margin-inline: ${minus(cssTheme.layout.spacing.s400)};
  ${linariaMq.desktopSm} {
    padding-top: ${cssTheme.layout.spacing.s200};
    padding-bottom: ${cssTheme.layout.spacing.s400};
    width: 100%;
    margin-inline: 0;
  }
`
export const Section = styled.section`
  min-width: 0;
  width: 100%;
  box-sizing: border-box;
  padding: ${cssTheme.layout.spacing.s500} 0;
  background: ${cssTheme.colors.background.neutral.secondary};
  overflow: hidden;
  ${linariaMq.desktopSm} {
    padding: ${cssTheme.layout.spacing.s600} 0;
    border-radius: ${cssTheme.layout.radius.xl};
  }
`
export const Card = styled.div`
  color: inherit;
  text-decoration: none;
  flex: 0 0 ${CARD_WIDTH}px;
  width: ${CARD_WIDTH}px;
  box-sizing: border-box;
  overflow: hidden;
  text-align: start;
  cursor: pointer;
  background: ${cssTheme.colors.background.neutral.primary};
  border: ${cssTheme.layout.borderWidth.bw100} solid
    ${cssTheme.colors.border.neutral.secondary};
  border-radius: ${cssTheme.layout.radius.lg};
  display: flex;
  flex-direction: column;
`
export const CardLink = styled(NoStyleLink)`
  display: flex;
  flex: 1;
  flex-direction: column;

  &:focus-visible {
    outline: ${cssTheme.layout.borderWidth.bw200} solid
      ${cssTheme.colors.border.interactive.primary};
    outline-offset: calc(-1 * ${cssTheme.layout.borderWidth.bw200});
  }
`
export const PhotoWrapper = styled.div`
  width: 100%;
  aspect-ratio: 16 / 9;
  position: relative;
  overflow: hidden;
  flex-shrink: 0;
`
export const Badge = styled.div`
  position: absolute;
  top: ${cssTheme.layout.spacing.s300};
  inset-inline-start: ${cssTheme.layout.spacing.s300};
  max-width: calc(100% - 2 * ${cssTheme.layout.spacing.s300});
`
export const HotelName = styled(Text)<{isRtlLanguage: boolean}>`
  text-align: ${({isRtlLanguage}) => (isRtlLanguage ? 'end' : 'start')};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`
